const Index = () => import("./index");
const DaySummary = () => import("./DaySummary.vue");

export default [{
  path: "daySummary",
  name: "daySummary-report",
  component: Index,
  redirect: {
    name: "daySummary",
  },
  children: [{
    path: "date",
    name: "daySummary",
    component: DaySummary,
  }],
},
]
